import React from 'react';
import styled, { CSSProp } from 'styled-components';

const ButtonSt = {
  Wrap: styled.button<ButtonProps>`
    position: relative;
    border-radius: ${(p) => (p.$isTabButton ? '50px' : '8px')};
    box-sizing: border-box;
    width: ${(p) => (p.width ? p.width + 'px' : '100%')};
    height: ${(p) => (p.height ? p.height + 'px' : '40px')};
    transition: 0.4s;
    overflow: hidden;

    // 일반 컬러버튼
    ${(p) =>
      !p.$isGradientBtn &&
      `
        background: ${p.$colorType === 'white' ? '#fff' : p.$colorType === 'peacock' ? '#0A95B4' : ''};
        border: ${p.$colorType === 'white' ? '2px solid #d4d8df' : p.$colorType === 'peacock' ? '2px solid rgba(255,255,255,.4)' : 'none'};
        &:hover{
          background:${p.$colorType === 'white' ? '#E5E8EC' : p.$colorType === 'peacock' ? '#0084A1' : ''};
        }
        &:active{
          background:${p.$colorType === 'white' ? '#A2ACB5' : p.$colorType === 'peacock' ? '#00738D' : ''};
          >span{
            color:#fff;
          }
        }
    
    `}

    // 그라데이션 버튼
    ${(p) =>
      p.$isGradientBtn
        ? p.$isTabButton
          ? `
    background: linear-gradient(to right, #0077a666, #00bea366);
    box-shadow: 2px 4px 6px 1px #0000000a;
    &:before,
    &:after {
      transition: 0.4s;
      position: absolute;
      left: 2px;
      top: 2px;
      content: '';
      width: calc(100% - 4px);
      height: calc(100% - 4px);
      border-radius: 50px;
    }
    &:before {
      opacity: 1;
      background: #fff;
    }
    &:after {
      opacity: 0;
      background: linear-gradient(to right, #4b8ce7, #80c258);
    }
    &.active {
      background: #fff;
      &:before {
        opacity: 0;
      }
      &:after {
        opacity: 1;
      }
    }
    `
          : `
   &:before,
    &:after {
      border-radius: 8px;
      box-sizing: border-box;
      border: 2px solid rgba(255, 255, 255, 0.4);
      position: absolute;
      left: 0;
      top: 0;
      content: '';
      width: 100%;
      height: 100%;
      transition: 0.4s;
    }
    &:before {
      opacity: 1;
      background: linear-gradient(to right, #4b8ce7, #80c258);
    }
    &:after {
      opacity: 0;
      background: linear-gradient(to right, #0077a6, #00bea3);
    }
    &:hover {
      &:before {
        opacity: 0;
      }
      &:after {
        opacity: 1;
      }
    }
    `
        : ''};
  `,
  Text: styled.span<ButtonProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
    transition: 0.4s;
    color: ${(p) =>
      p.$isGradientBtn
        ? //그라데이션 버튼 텍스트
          p.$isTabButton && !p.$active
          ? '#677179'
          : '#fff'
        : //일반버튼 텍스트
          p.$colorType === 'white'
          ? '#7C868F'
          : p.$colorType === 'peacock'
            ? '#fff'
            : 'inherit'};
    font-size: ${(p) => (p.$fontSize ? p.$fontSize + 'px' : '16px')};
    font-weight: 600;
    &:before,
    &:after {
      content: '';
      width: ${(p) => (p.$icoSize ? p.$icoSize + 'px' : '24px')};
      height: ${(p) => (p.$icoSize ? p.$icoSize + 'px' : '24px')};
    }
    &:before {
      display: ${(p) => (p.$leftIco ? 'block' : 'none')};
      margin-right: ${(p) => (p.$icoSpacing ? p.$icoSpacing + 'px' : '3px')};
      background: url(${(p) => (p.$leftIco ? p.$leftIco : '')}) no-repeat center;
    }
    &:after {
      display: ${(p) => (p.$rightIco ? 'block' : 'none')};
      margin-left: ${(p) => (p.$icoSpacing ? p.$icoSpacing + 'px' : '3px')};
      background: url(${(p) => (p.$rightIco ? p.$rightIco : '')}) no-repeat center;
    }
  `,
};

interface ButtonProps {
  width?: number;
  height?: number;
  text?: string;
  $isTabButton?: boolean;
  $active?: boolean;
  onClick?: () => void;
  $leftIco?: string;
  $rightIco?: string;
  $icoSize?: number;
  $icoSpacing?: number;
  $fontSize?: number;
  $isGradientBtn?: boolean;
  $colorType?: 'white' | 'peacock';
  style?: CSSProp;
}

const Button = ({ width, height, text, $isTabButton = false, $active, onClick, $leftIco, $rightIco, $icoSize, $icoSpacing, $isGradientBtn, $colorType, $fontSize, style }: ButtonProps) => {
  return (
    <ButtonSt.Wrap style={style} width={width} height={height} $isTabButton={$isTabButton} className={$active ? 'active' : ''} onClick={onClick} $isGradientBtn={$isGradientBtn} $colorType={$colorType}>
      <ButtonSt.Text $isTabButton={$isTabButton} $isGradientBtn={$isGradientBtn} $active={$active} $fontSize={$fontSize} $leftIco={$leftIco} $rightIco={$rightIco} $icoSize={$icoSize} $icoSpacing={$icoSpacing} $colorType={$colorType}>
        {text}
      </ButtonSt.Text>
    </ButtonSt.Wrap>
  );
};

export default Button;
